import "moment/locale/cs.js";
import "moment/locale/pl.js";
import "moment/locale/hu.js";
import "moment/locale/de.js";
import "moment/locale/sk.js";

import moment from 'moment'

window.moment = moment
